import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from "react-hot-toast";
import { AuthProvider } from './context/AuthContext';
import { DashboardChatProvider } from './context/DashboardChatContext';
import LoginForm from './pages/LoginForm';
import ProtectedRoute from './pages/ProtectedRoute';
import RoleProtectedRoute from './pages/RoleProtectedRoute';
import { SidebarProvider } from './components/ui/sidebar';
import { AppSidebar } from './components/app-sidebar';
import Dashboard from './pages/Dashboard';
import NotFound from './component/pageNotFound';
import { AppHeader } from './components/app-header';
import DashboardChatBot from './components/dashboard/DashboardChatBot';
import UserManagementPage from './pages/UserManagement';
import EmployeeManagement from "./pages/EmployeeManagement"
import PromosTransactions from './pages/PromosTransactions'
import PettyCash from './pages/PettyCash';
import DealerTipsPage from './pages/DealerTipsRecords';
import WaitressTipsRecords from './pages/WaitressTipsRecords';
import BartenderTipsRecords from './pages/BartenderTipsRecords';
import OtherTipsRecords from './pages/OtherTipsRecords';
import ResetPasswordPage from './pages/ResetPasswordPage';
import PlayerProfileModule from './pages/PlayerProfileModulePage';
import TournamentPokerChips from './pages/TournamenPokerChips';
import PokerCashBox from './pages/PokerCashBox';
import TokenReserves from './pages/TokenReserves';
import TournamentHouseFees from './pages/TournamentHouseFees';
import StartingClosingTablesTime from './pages/StartingClosingTablesTime';
// import LeaderboardAdmin from './pages/LeaderboardAdmin';
import TournamentLeaderboardPage from './pages/TournamentLeaderboardPage';
import SmsLogsPage from './pages/SmsLogsPage';
// import TournamentLeaderboard from './pages/TournamentLeaderboard';

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <Toaster position="top-right" reverseOrder={false} />
        <Routes>
          <Route path="/login" element={<LoginForm />} />
          <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <RoleProtectedRoute>
                <DashboardChatProvider>
                <SidebarProvider>
                  <div className="flex h-screen overflow-hidden">
                    <AppSidebar />
                    <div className="flex min-h-0 min-w-0 flex-1 flex-col">
                      <AppHeader />
                      <main className="min-h-0 flex-1 overflow-y-auto overflow-x-hidden pl-20">
                      <Routes>
                        <Route path="/" element={<Dashboard />} />
                        <Route path="/user-management" element={<UserManagementPage />} />
                        <Route path="/employee-management" element={<EmployeeManagement />} />
                        <Route path="/promos" element={<PromosTransactions />} />
                        <Route path="/petty-cash" element={<PettyCash />} />
                        <Route path="/dealer-tips" element={<DealerTipsPage />} />
                        <Route path="/waitress-tips" element={<WaitressTipsRecords />} />
                        <Route path="/floor-tips" element={<BartenderTipsRecords />} />
                        <Route path="/bartender-tips" element={<Navigate to="/floor-tips" replace />} />
                        <Route path="/other-tips" element={<OtherTipsRecords />} />
                        <Route path="/player-profiles" element={<PlayerProfileModule />} />
                        <Route path="/tournament-poker-chips" element={<TournamentPokerChips />} />
                        <Route path="/poker-cash-box" element={<PokerCashBox />} />
                        <Route path="/tournament-house-fees" element={<TournamentHouseFees />} />
                        <Route path="/token-reserves" element={<TokenReserves />} />
                        <Route path="/starting-closing-tables-time" element={<StartingClosingTablesTime />} />
                        {/* <Route path="/leaderboard-admin" element={<LeaderboardAdmin />} /> */}
                        <Route path="/sms-logs" element={<SmsLogsPage />} />
                        <Route path="/tournament-leaderboard" element={<TournamentLeaderboardPage />} />
                        {/* <Route path="/tournament-leaderboard" element={<TournamentLeaderboard />} /> */}
                        <Route path="*" element={<NotFound />} />
                      </Routes>
                      </main>
                    </div>
                  </div>
                  <DashboardChatBot />
                </SidebarProvider>
                </DashboardChatProvider>
                </RoleProtectedRoute>
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;
